import { render } from "./twoindex.vue?vue&type=template&id=79d1d182&scoped=true"
import script from "./twoindex.vue?vue&type=script&lang=js"
export * from "./twoindex.vue?vue&type=script&lang=js"

import "./twoindex.vue?vue&type=style&index=0&id=79d1d182&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d1d182"]])

export default __exports__